import React, { useContext, useEffect, useState } from 'react'
import Modal from 'react-bootstrap/Modal';
import './NewLeaderboardModal.css'
import '../../../assets/css/modal.css'
import { dataContext } from '../../../App';
import activityLogSubmission from '../../../helper/activitylog';
import analyticEvent from '../../../helper/gaEvent';
import { fetchLeaderboardByLeaderboarName, fetchLeaderboardForIndividual } from '../../../services';
import NewLeaderboardContainer from './NewLeaderboardContainer';
import { Spinner } from 'react-bootstrap';
const NewLeaderboardModal = ({ showNewLeaderboardModal, setShowNewLeaderboardModal, activeBottom }) => {
  const { events, playerData, activeLeaderboardName,setActiveLeaderboardName, token } = useContext(dataContext);
  const [leaderBoardData, setLeaderBoardData] = useState([]);
  const [rankOneData, setRankOneData] = useState({});
  const [rankTwoData, setRankTwoData] = useState({});
  const [rankThreeData, setRankThreeData] = useState({});
  const [currentUserData, setCurrentUserData] = useState({});
  const [isLoading, setIsLoading] = useState(false);


  function hideModalOperation() {
    setShowNewLeaderboardModal(false)
  }
  useEffect(() => {
    setIsLoading(true);
    fetchLeaderboardByLeaderboarName(activeLeaderboardName).then(res => {
      console.log(res);
      let totalData = res;
      totalData = totalData.filter(item => !(item.score === 0 && item.time_taken === 0));
      if (totalData.length > 0) { setRankOneData(totalData[0]); } else { setRankOneData({}); }
      if (totalData.length > 1) { setRankTwoData(totalData[1]); } else { setRankTwoData({}); }
      if (totalData.length > 2) { setRankThreeData(totalData[2]); } else { setRankThreeData({}); }
      if (totalData.length > 3) { setLeaderBoardData(totalData.slice(3)); } else { setLeaderBoardData([]); }
      setIsLoading(false);
    })
    fetchLeaderboardForIndividual(activeLeaderboardName,token,playerData).then(res => {
      console.log(res);
      setCurrentUserData(res);
    })

  }, [activeLeaderboardName])
  useEffect(() => {
    activityLogSubmission("NewLeaderboardModal");
    analyticEvent('NewLeaderboardModal', 'NewLeaderboardModal-view')
  }, [])


  return (
    <>
      <Modal show={showNewLeaderboardModal} centered dialogClassName="modal-dialog" contentClassName="modalContentNewLeaderboardModal" onHide={hideModalOperation}>
        <Modal.Header closeButton style={{ fontSize: '20px', fontWeight: 'bold', color: '#281364', display: 'flex', justifyContent: 'center', alignItems: 'center' }} >
          <div style={{ flex: 1, textAlign: 'center', position: 'relative', left: '12px' }}>
            {activeBottom === 'leader' && <span>Leaderboard</span>}
          </div>
        </Modal.Header>
        <Modal.Body style={{ maxHeight: "80vh", overflow: "scroll", display: 'block', overflowX: 'hidden', padding: '0px 0px 24px 0px' }}>
          <NewLeaderboardContainer setActiveLeaderboardName={setActiveLeaderboardName} activeLeaderboardName={activeLeaderboardName} leaderBoardData={leaderBoardData} rankOneData={rankOneData} rankTwoData={rankTwoData} rankThreeData={rankThreeData} currentUserData={currentUserData} />
          {isLoading && <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%', position: 'absolute', top: '0', left: '0', right: '0', bottom: '0', backgroundColor: 'rgba(0,0,0,0.1)' }}><Spinner animation="border" style={{ color: '#281364' }} size="sm" /></div>}
        </Modal.Body>
      </Modal>
    </>
  )
}

export default NewLeaderboardModal